export default "__VITE_ASSET__BLF5rqIU__"